module.exports = __webpack_public_path__ + "img/tip.b3a76ffd.webp";